import React, { useEffect, useState } from 'react';
import Topbar from '../../components/Topbar';
import Leftbar from '../../components/Leftsidebar';
import Lenderlist from './Lenderlist';
import Analytics from '../../components/Listinganalytics';
import { Link, useLocation } from 'react-router-dom';


const Lenders = () => {


  const [showSidebar, setShowSidebar] = useState(false);
  const [activeTab, setActiveTab] = useState('lenderlist');


  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };




  return (
    <>

      <div className="g-sidenav-show bg-gray-100 min-vh-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar} handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />


            <div className="header header-bg-lender pt-3">
              <div className="col-lg-6 col-7">
                <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4" style={{marginLeft:'30px'}}>
                  <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                    <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                    <li className="breadcrumb-item mt-2"><span className='' style={{ color: "#f6f9fc" }}>Lenders</span></li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex justify-content-center pt-2">
                <div
                  className={`List-tab ${activeTab === 'lenderlist' ? 'List-tab-active' : 'List-tab-normal'} mr-3`}
                  onClick={() => setActiveTab('lenderlist')}
                  style={{ cursor: 'pointer' }}
                >
                  <span>Lenders</span>
                </div>
                <div
                  className={`List-tab ${activeTab === 'analytics' ? 'List-tab-active' : 'List-tab-normal'}`}
                  onClick={() => setActiveTab('analytics')}
                  style={{ cursor: 'pointer' }}
                >
                  <span>Analytics</span>
                </div>
              </div>

            </div>

            <div className='conatiner-fluid tab-component'>
              {activeTab === 'lenderlist' && <Lenderlist />}
              {activeTab === 'analytics' && <Analytics />}
            </div>

          </main>
        </div>
      </div>
    </>

  );
};

export default Lenders;
